<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_3365_30480)">
<circle cx="12" cy="12" r="10.5" stroke="#000" stroke-width="1.5"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.82486 19.4428L4.3294 19.8763L3.6709 19.1237L7.38813 15.8711C7.66157 15.6319 8.01255 15.5 8.37589 15.5H15.6244C15.9877 15.5 16.3387 15.6319 16.6122 15.8711L20.3294 19.1237L19.6709 19.8763L19.1868 19.4527L19.6229 19.932C17.6459 21.832 14.9601 23.0001 12.0015 23.0001C9.04291 23.0001 6.35713 21.832 4.38013 19.932L4.82486 19.4428Z" fill="#000"/>
<circle cx="12" cy="10.5" r="3.5" fill="#000"/>
</g>
<defs>
<clipPath id="clip0_3365_30480">
<rect width="24" height="24" fill="white"/>
</clipPath>
</defs>
</svg>
